export const TWILIO_EVENT_PARTICIPANT_JOINED = "twilio:onParticipantJoined";
export const TWILIO_EVENT_MESSAGE_ADDED = "twilio:onMessageAdded";
export const TWILIO_EVENT_MESSAGE_READ = "twilio:onMessageRead";
export const TWILIO_EVENT_MESSAGE_SENT = "twilio:onMessageSent";
